<template>
  <BaseContainer class="overflow-hidden">
    <div class="flex items-center justify-between mb-6">
      <h2
        :class="
          twJoin(
            'md:text-5xl !leading-[62px]',
            recommendation && !style && '!text-[32px]',
            style && '!md:text-5xl font-bold md:font-normal',
            style ? 'text-2xl' : 'text-[32px]'
          )
        "
      >
        {{ title }}
      </h2>
      <div class="flex gap-x-2">
        <div
          :class="
            twJoin(
              props.slideKey +
                '-c-button-prev w-8 h-8 flex items-center justify-center rounded bg-black text-white cursor-pointer'
            )
          "
        >
          <Icon name="arrow-left" />
        </div>
        <div
          :class="
            twJoin(
              props.slideKey +
                '-c-button-next w-8 h-8 flex items-center justify-center rounded bg-black text-white cursor-pointer'
            )
          "
        >
          <Icon name="arrow-right" />
        </div>
      </div>
    </div>
    <div v-if="isLoading || clickloading">
      <nuxt-error-boundary @error="() => {}">
        <Swiper
          :modules="[SwiperEffectCreative, SwiperNavigation]"
          :slides-per-view="width < 768 ? 2 : 'auto'"
          :space-between="recommendation ? 24 : 16"
          :navigation="{
            enabled: true,
            disabledClass: '!bg-gray-10 !text-typo-disabled',
            nextEl: `.${props.slideKey}-c-button-next`,
            prevEl: `.${props.slideKey}-c-button-prev`
          }"
          :creative-effect="{
            prev: {
              shadow: false,
              translate: ['-20%', 0, -1]
            },
            next: {
              translate: ['100%', 0, 0]
            }
          }"
          class="!overflow-visible md:!overflow-clip"
        >
          <SwiperSlide
            v-for="(item, index) in new Array(4).fill(0)"
            :key="index"
            :class="
              twJoin(
                'min-w-[230px] max-w-[240px] md:max-w-[282px]',
                recommendation &&
                  '!max-w-[unset] md:!max-w-[277px] !min-w-[unset] md:!min-w-[230px]'
              )
            "
          >
            <ProductItemThumbnailSkeletonComponent
              :key="index"
              product-listing
            />
          </SwiperSlide>
        </Swiper>
      </nuxt-error-boundary>
    </div>
    <div v-else>
      <nuxt-error-boundary @error="() => {}">
        <Swiper
          :loop="false"
          :modules="[SwiperEffectCreative, SwiperNavigation]"
          :slides-per-view="width < 768 ? 2 : 'auto'"
          :space-between="recommendation ? 24 : 16"
          :navigation="{
            enabled: true,
            disabledClass: '!bg-gray-10 !text-typo-disabled',
            nextEl: `.${props.slideKey}-c-button-next`,
            prevEl: `.${props.slideKey}-c-button-prev`
          }"
          :creative-effect="{
            prev: {
              shadow: false,
              translate: ['-20%', 0, -1]
            },
            next: {
              translate: ['100%', 0, 0]
            }
          }"
          class="!overflow-visible md:!overflow-clip"
        >
          <SwiperSlide
            v-for="item in data"
            :key="item.objectID"
            :class="
              twJoin(
                'min-w-[230px] max-w-[240px] md:max-w-[282px]',
                recommendation &&
                  '!max-w-[unset] md:!max-w-[277px] !min-w-[unset] md:!min-w-[230px]'
              )
            "
          >
            <ProductListItemThumbnailComponent
              v-if="item.objectID"
              :key="item.objectID"
              product-listing
              :image-url="item.thumbnail_image_url"
              :name="item.display_name_en"
              :price="item.price"
              :tags="[
                ...item.artwork_tags_mapping,
                ...item.product_tag_mapping
              ]"
              :product-slug="item.product_slug"
              :artwork-slug="item.artwork_slug"
              :device-option-available="item.device_option_available"
              :artwork-name="item.artist_name_en"
              product-detail-type
              @loading="handleLoading"
            />
          </SwiperSlide>
        </Swiper>
      </nuxt-error-boundary>
    </div>
  </BaseContainer>
</template>

<script lang="ts" setup>
import { twJoin } from 'tailwind-merge'

const ProductItemThumbnailSkeletonComponent = defineAsyncComponent({
  loader: () => import('./ProductListItemThumbnailSkeleton.vue')
})
const ProductListItemThumbnailComponent = defineAsyncComponent({
  loader: () => import('./../v2/ProductListItemThumbnail.vue')
})

const props = defineProps<{
  slideKey: string
  recommendation?: boolean
  style?: boolean
  title: string
  data: AlgoliaProductV2[]
  isLoading?: boolean
}>()
const clickloading = ref(false)
const handleLoading = (value: boolean) => {
  clickloading.value = value
  window.scrollTo({
    top: 0,
    behavior: 'auto'
  })
}
const { width } = useWindowSize()
</script>
